// @ts-strict-ignore
import {AfterViewChecked, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {LMDetailSectionBase} from './lm-detail-section-base';
import {LandmarkPanel} from '@form/lm-form.model';
import {LMDashboardViewComponent} from '@dashboard/lm-dashboard-view.component';
import {Observable, Observer, of} from 'rxjs';
import {LMPanelTransactionEvent, LMRefreshRequest} from "@app/components";

@Component({
  selector: 'lm-detail-section-dashboard',
  standalone: false,
  template: `
      @if (useTwelveColumnGrid) {
        @if (activated) {
          <lm-twelve-column-grid
            [dashboardPanels]="panels"
            [fromDataView]="fromDataView"
            [panelVisibilityUpdateTimeStamp]="updateVisibilityTimestamp"
            [isFlyoutContent]="isFlyoutContent"
            (uiLinkEvent)="onUILinkEvent($event)"
            (dashboardContentDisplayed)="onDashboardContentDisplayed($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"></lm-twelve-column-grid>
        }
      } @else {
        @if (activated) {
          <lm-dashboard-view #lmDashBoardComponent
            [dashboardPanels]="panels"
            [fromDataView]="fromDataView"
            [columns]="columns"
            [panelVisibilityUpdateTimeStamp]="updateVisibilityTimestamp"
            [refreshAfterInit]="true"
            [isFlyoutContent]="isFlyoutContent"
            (uiLinkEvent)="onUILinkEvent($event)"
            (sendContextMessageEvent)="onSendContextMessageEvent($event)"
            (dashboardContentDisplayed)="onDashboardContentDisplayed($event)"
            (panelTransactionEvent)="onPanelTransactionEvent($event)"
            (drillAroundEvent)="onDrillAroundEvent($event)"
          ></lm-dashboard-view>
        }
      }
      `
})
export class LMDetailSectionDashBoardComponent implements LMDetailSectionBase, AfterViewChecked {
  @ViewChild('lmDashBoardComponent') lmDashBoardComponent: LMDashboardViewComponent;

  @Output() detailSectionDisplayed = new EventEmitter<any>();
  @Output() sendContextMessageEvent = new EventEmitter<any>();
  @Output() uiLinkEvent = new EventEmitter<any>();
  @Output() panelTransactionEvent = new EventEmitter<LMPanelTransactionEvent>();
  @Output() drillAroundEvent = new EventEmitter<LMDrillAroundEvent>();

  @Input() public activated: boolean;
  @Input() public panels: Array<LandmarkPanel> = null;
  @Input() public columns: 3 | 4 = 3;
  @Input() public set fromDataView(fromDataView: LMDataView) {
    this._fromDataView = fromDataView;
  }
  public get fromDataView(): LMDataView {
    if (this.needsReload) {
      return null;
    }
    return this._fromDataView;
  }

  @Input() needsReload: boolean;
  @Input() useTwelveColumnGrid = false;
  @Input() updateVisibilityTimestamp: number;
  @Input() isFlyoutContent = false;
  private _fromDataView: LMDataView = null;
  private _refreshDashboard = false;

  constructor() {  }

  get type() {
    return 'dashboard';
  }

  ngAfterViewChecked(): void {
    if (this._refreshDashboard && this.lmDashBoardComponent) {
      this._refreshDashboard = false;
      this.lmDashBoardComponent.refreshHomepage(false);
    }
  }

  public refreshDashboard() {
    this._refreshDashboard = true;
  }

  isModified(): boolean {
    return false;
  }

  saveDetailSectionState() {
    if (this.lmDashBoardComponent) {
      this.lmDashBoardComponent.saveDashboardViewState();
    }
  }

  clearDetailSectionState() {
    if (this.lmDashBoardComponent) {
      this.lmDashBoardComponent.clearDashboardViewState();
    }
  }

  onSendContextMessageEvent(event: any) {
    this.sendContextMessageEvent.emit(event);
  }

  onDashboardContentDisplayed(event) {
    this.detailSectionDisplayed.emit(event);
  }

  onUILinkEvent(event: any) {
    this.uiLinkEvent.emit(event);
  }

  onPanelTransactionEvent(event: LMPanelTransactionEvent) {
    this.panelTransactionEvent.emit(event);
  }

  onDrillAroundEvent(event: LMDrillAroundEvent) {
    this.drillAroundEvent.emit(event);
  }

  save(callBack: Observer<boolean>) {
    // nothing to save
    callBack.next(true);
    callBack.complete();
  }

  refresh(request?: LMRefreshRequest): Observable<boolean> {
    if (this.lmDashBoardComponent) {
      return this.lmDashBoardComponent.refresh(request);
    } else {
      return of(true);
    }
  }
}
